/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Editor_Horizontal_RuleInputs */

const en_common_editor_horizontal_rule = /** @type {(inputs: Common_Editor_Horizontal_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Horizontal rule`)
};

const zh_common_editor_horizontal_rule = /** @type {(inputs: Common_Editor_Horizontal_RuleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`水平分隔线`)
};

/**
* | output |
* | --- |
* | "Horizontal rule" |
*
* @param {Common_Editor_Horizontal_RuleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_editor_horizontal_rule = /** @type {((inputs?: Common_Editor_Horizontal_RuleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Editor_Horizontal_RuleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_editor_horizontal_rule(inputs)
	return zh_common_editor_horizontal_rule(inputs)
});
export { common_editor_horizontal_rule as "common.editor.horizontal_rule" }